'use client'

import { useCallback, useEffect, useState } from 'react'
import type { WalletUsageResponse } from '@/app/api/wallet/usage/usage-response'

export function useWalletUsage() {
  const [data, setData] = useState<WalletUsageResponse | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const mutate = useCallback(async () => {
    setError(null)
    setIsLoading(true)
    try {
      const res = await fetch('/api/wallet/usage')
      const payload = await res.json()
      if (!res.ok) throw new Error(payload.error || 'Unable to load usage')
      setData(payload as WalletUsageResponse)
      return payload as WalletUsageResponse
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unable to load usage'
      setError(message)
      throw err
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    void mutate().catch(() => {})
  }, [mutate])

  return { data, isLoading, error, mutate, setData }
}
